import BundleVersionListRowDetails from './BundleVersionListRowDetails';

export default BundleVersionListRowDetails;
